import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Modal from '../../components/Modal';
import Toast from '../../components/Toast';

export default function Deceased() {
  const [people, setPeople] = useState([]);
  const [graves, setGraves] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [toast, setToast] = useState(null);
  const [form, setForm] = useState({ name: '', birth_date: '', death_date: '', grave_id: '' });

  const load = () => {
    setLoading(true);
    Promise.all([
      api.get('/admin/deceased', { params: { search } }),
      api.get('/admin/graves'),
    ]).then(([peopleRes, gravesRes]) => {
      setPeople(peopleRes.data);
      setGraves(gravesRes.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  useEffect(() => {
    const t = setTimeout(load, 300);
    return () => clearTimeout(t);
  }, [search]);

  const handleNew = () => {
    setEditing(null);
    setForm({ name: '', birth_date: '', death_date: '', grave_id: '' });
    setModalOpen(true);
  };

  const handleEdit = (p) => {
    setEditing(p);
    setForm({
      name: p.name,
      birth_date: p.birth_date ? p.birth_date.substring(0, 10) : '',
      death_date: p.death_date ? p.death_date.substring(0, 10) : '',
      grave_id: p.grave_id,
    });
    setModalOpen(true);
  };

  const handleSave = async () => {
    if (!form.name || !form.grave_id) {
      setToast({ message: 'Nome e jazigo são obrigatórios', type: 'error' });
      return;
    }
    try {
      if (editing) {
        await api.put(`/admin/deceased/${editing.id}`, form);
        setToast({ message: 'Sepultado atualizado' });
      } else {
        await api.post('/admin/deceased', form);
        setToast({ message: 'Sepultado cadastrado' });
      }
      setModalOpen(false);
      load();
    } catch (err) {
      setToast({ message: err.response?.data?.error || 'Erro ao salvar', type: 'error' });
    }
  };

  const handleDelete = async (p) => {
    if (!window.confirm(`Excluir registro de ${p.name}?`)) return;
    try {
      await api.delete(`/admin/deceased/${p.id}`);
      setToast({ message: 'Registro excluído' });
      load();
    } catch {
      setToast({ message: 'Erro ao excluir', type: 'error' });
    }
  };

  const toggleActive = async (p) => {
    const next = !(p.active !== false);
    const label = next ? 'ativar' : 'inativar';
    if (!window.confirm(`${next ? 'Ativar' : 'Inativar'} ${p.name} da busca pública?`)) return;
    try {
      await api.put(`/admin/deceased/${p.id}/active`, { active: next });
      setToast({ message: next ? 'Ativado na busca' : 'Inativado da busca' });
      load();
    } catch {
      setToast({ message: 'Erro ao atualizar status', type: 'error' });
    }
  };

  const formatDate = (d) => {
    if (!d) return '—';
    const [y, m, day] = d.slice(0, 10).split('-');
    return y && m && day ? `${day}/${m}/${y}` : '—';
  };
  const shown = people.slice(0, 500);

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h1>Sepultados</h1>
          <p>Gerencie os registros de pessoas sepultadas.</p>
        </div>
        <button className="btn-primary" onClick={handleNew}>+ NOVO SEPULTADO</button>
      </div>

      <div className="filters-bar">
        <input
          type="text"
          className="form-input search-field"
          placeholder="Buscar por nome..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Nascimento</th>
              <th>Falecimento</th>
              <th>Jazigo</th>
              <th>Quadra</th>
              <th>Setor</th>
              <th>Busca</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="8" style={{ textAlign: 'center', padding: 40 }}>Carregando...</td></tr>
            ) : shown.length === 0 ? (
              <tr><td colSpan="8" style={{ textAlign: 'center', padding: 40, color: 'var(--texto-secundario)' }}>Nenhum registro encontrado.</td></tr>
            ) : shown.map((p) => (
              <tr key={p.id} style={p.active === false ? { opacity: 0.55 } : undefined}>
                <td><strong>{p.name}</strong></td>
                <td>{formatDate(p.birth_date)}</td>
                <td>{formatDate(p.death_date)}</td>
                <td>{p.number}</td>
                <td>{p.block}</td>
                <td>{p.sector}</td>
                <td>
                  {p.active === false ? (
                    <span className="gps-badge warn" title="Oculto da busca pública — solicitação de privacidade">Inativo</span>
                  ) : (
                    <span className="gps-badge ok">Ativo</span>
                  )}
                </td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <button
                    className="btn-secondary"
                    style={{ padding: '6px 12px', fontSize: 12, marginRight: 6 }}
                    onClick={() => toggleActive(p)}
                    title={p.active === false ? 'Voltar a aparecer na busca pública' : 'Ocultar da busca pública'}
                  >
                    {p.active === false ? 'Ativar busca' : 'Inativar busca'}
                  </button>
                  <button className="btn-secondary" style={{ padding: '6px 12px', fontSize: 12, marginRight: 6 }} onClick={() => handleEdit(p)}>Editar</button>
                  <button className="btn-secondary" style={{ padding: '6px 12px', fontSize: 12, color: 'var(--erro)', borderColor: '#E5B8B8' }} onClick={() => handleDelete(p)}>Excluir</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {people.length > shown.length && (
          <div style={{ padding: '12px 16px', fontSize: 13, color: 'var(--texto-secundario)', textAlign: 'center' }}>
            Mostrando {shown.length} de {people.length} registros — refine a busca por nome.
          </div>
        )}
      </div>

      {modalOpen && (
        <Modal
          title={editing ? 'Editar Sepultado' : 'Novo Sepultado'}
          onClose={() => setModalOpen(false)}
          footer={
            <>
              <button className="btn-secondary" onClick={() => setModalOpen(false)}>Cancelar</button>
              <button className="btn-primary" onClick={handleSave}>Salvar</button>
            </>
          }
        >
          <div className="form-group">
            <label className="form-label">Nome completo</label>
            <input type="text" className="form-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nome da pessoa" />
          </div>
          <div className="form-group">
            <label className="form-label">Jazigo</label>
            <select className="form-select" value={form.grave_id} onChange={(e) => setForm({ ...form, grave_id: e.target.value })}>
              <option value="">Selecione o jazigo</option>
              {graves.map((g) => (
                <option key={g.id} value={g.id}>
                  Quadra {g.block} / Setor {g.sector} / Jazigo {g.number} {g.deceased_name ? '(ocupado)' : '(livre)'}
                </option>
              ))}
            </select>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div className="form-group">
              <label className="form-label">Data de nascimento</label>
              <input type="date" className="form-input" value={form.birth_date} onChange={(e) => setForm({ ...form, birth_date: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Data de falecimento</label>
              <input type="date" className="form-input" value={form.death_date} onChange={(e) => setForm({ ...form, death_date: e.target.value })} />
            </div>
          </div>
        </Modal>
      )}

      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
    </div>
  );
}
